module.exports = __webpack_public_path__ + "img/QRPaymentKH.16db9c81.png";